import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
//import "./popupModal.scss";
import {
  Button,
  Grid,
  Box,
  Paper,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  TableContainer,
  Table,
  TableHead,
  IconButton,
  Tooltip,
} from "@mui/material";
import "./dPFilterModal.scss";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function BasicModal({
  modalOpen,
  handleClose,
  handleSubmit,
  data,
  handleFilterEdit,
  handleDelete,
}) {
  if (!data || !data.data || data.data.length === 0) {
    return <div>No data available</div>;
  }

  const handleEditAndClose = (row) => {
    handleFilterEdit(row);
    handleClose();
  };
  const handlefilterDelete = (row) => {
    handleDelete(row);
    handleClose();;
  }
  return (
    <div>
      {/* {"modalOpen"} */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-describedby="modal-modal-description"
      >
        <Box component={Paper} className="dp-filter-modal-box" style={{maxHeight:"505px", overflow:"scroll"}}>
          <Grid container className="modal-popup">
            <Grid item>
              <TableContainer className="datapoint-map-container">
                <Table className="table-output" aria-label="simple table">
                  <TableHead style={{ border: "1px solid " }}>
                    <TableRow>
                      <TableCell>Formula Name</TableCell>
                      <TableCell> Unique Column Header</TableCell>
                      <TableCell> Non unique headers</TableCell>
                      <TableCell>Edit Filter's</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.data.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">{row.name}</TableCell>
                        <TableCell align="left">
                          <Tooltip
                            title={row.unique_column_headers.join(", ")}
                            enterDelay={0}
                          >
                            <span>
                              {row.unique_column_headers.slice(0, 2).join(", ")}
                              {row.unique_column_headers.length > 2
                                ? "..."
                                : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="left">
                          <Tooltip
                            title={row.non_unique_column_headers.join(", ")}
                            enterDelay={0}
                          >
                            <span>
                              {row.non_unique_column_headers
                                .slice(0, 2)
                                .join(", ")}
                              {row.non_unique_column_headers.length > 2
                                ? "..."
                                : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Button onClick={() => handleEditAndClose(row)}>
                            <EditIcon />
                          </Button>
                          <Button onClick={() => handlefilterDelete(row)}> <DeleteIcon /> </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
